import type {ComponentExportStructure} from '@wix/document-services-types'
import _ from 'lodash'
import {unsetAndCleanEmptyObjects} from './mapFields'

export const packToQueryParams = (
    component: ComponentExportStructure,
    pathToUrl: string,
    pathToParam: Record<string, string>
): string => {
    const url = component[pathToUrl]
    const urlSearchParams = new URLSearchParams({})
    _.forOwn(pathToParam, (paramName, paramPath) => {
        const value = _.get(component, paramPath)
        if (!_.isNil(value)) {
            urlSearchParams.append(paramName, value)
            unsetAndCleanEmptyObjects(component, paramPath)
        }
    })
    if (Array.from(urlSearchParams).length > 0) {
        return `${url}?${urlSearchParams.toString()}`
    }
    return url
}

export const unpackFromQueryParams = (
    component: ComponentExportStructure,
    pathToUrl: string,
    paramToPath: Record<string, string>
): string => {
    const urlSplit = component[pathToUrl].split('?')
    if (urlSplit?.[1]) {
        const urlSearchParams = new URLSearchParams(urlSplit[1])
        _.forOwn(paramToPath, (paramPath, paramName) => {
            const value = urlSearchParams.get(paramName)
            if (!_.isNil(value)) {
                _.set(component, paramPath, value)
                urlSearchParams.delete(paramName)
            }
        })
        if (Array.from(urlSearchParams).length > 0) {
            return `${urlSplit[0]}?${urlSearchParams.toString()}`
        }
        return urlSplit[0]
    }
    return component[pathToUrl]
}

export const urlParamsUtil = {
    pack: packToQueryParams,
    unpack: unpackFromQueryParams
}
